import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { getCustomerPastProducts } from '../settlements.endpoints';
import { CustomerPastProductDto } from '../dto/settlements.dto';

export type GetCustomerPastProducts = UseQueryResult<CustomerPastProductDto[]> & {
    pastProducts: CustomerPastProductDto[];
};

export const useGetCustomerPastProducts = (orderId: string): GetCustomerPastProducts => {
    const hook = useQuery<CustomerPastProductDto[]>({
        queryKey: ['getCustomerPastProducts', orderId],
        queryFn: () => getCustomerPastProducts(orderId),
        retry: false,
        staleTime: Infinity,
        cacheTime: 24 * 60 * 60 * 1000, // 24 hours
    });

    return { ...hook, pastProducts: hook.data || [] };
};
